import React from 'react';
import _ from 'lodash';
import slugify from 'slugify';
import { Link, withPrefix } from 'gatsby';

import { HTMLContent } from '~components/Content';
import states from '~utils/states';
import { TableData, TableRow } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';

export default function EmergencyAbsenteeBallotRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const { stateCode } = states.filter((obj) => {
    return obj.stateSlug === stateSlug;
  })[0];
  const stateData = _.keyBy(state.nodes, 'field_type');

  // using this format to populate data to avoid errors when compiling locally
  const EmergencyBallotRules = stateData.emergency_ballot_laws
    ? stateData.emergency_ballot_laws.html
    : 'N/A';
  const AbsenteeBallotRequestDeadlineMail = stateData.absentee_deadline_mail
    ? stateData.absentee_deadline_mail.text
    : 'N/A';
  const AbsenteeBallotRequestDeadlineInPerson =
    stateData.absentee_deadline_in_person
      ? stateData.absentee_deadline_in_person.text
      : 'N/A';
  const AbsenteeBallotRequestDeadlineOnline = stateData.absentee_deadline_online
    ? stateData.absentee_deadline_online.text
    : 'N/A';
  const AbsenteeBallotReturnDeadlineMail = stateData.ballot_return_deadline_mail
    ? stateData.ballot_return_deadline_mail.text
    : 'N/A';
  const AbsenteeBallotReturnDeadlineInPerson =
    stateData.ballot_return_deadline_in_person
      ? stateData.ballot_return_deadline_in_person.text
      : 'N/A';
  const EmergencyBallotRequestEnd = stateData.emergency_ballot_request_deadline
    ? stateData.emergency_ballot_request_deadline.text
    : 'N/A';
  const EmergencyBallotReturnDeadline =
    stateData.emergency_ballot_return_deadline
      ? stateData.emergency_ballot_return_deadline.text
      : 'N/A';

  return (
    <TableRow>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'Emergency ballot rules',
            valueNode: (
              <div>
                <HTMLContent content={EmergencyBallotRules} />
              </div>
            ),
          },
          {
            title: 'Regular absentee ballot deadlines',
            valueNode: (
              <ul>
                <li>
                  <strong>Application deadline (in person): </strong>
                  {AbsenteeBallotRequestDeadlineInPerson || 'N/A'}
                </li>
                <li>
                  <strong>Application deadline (by mail): </strong>
                  {AbsenteeBallotRequestDeadlineMail || 'N/A'}
                </li>
                <li>
                  <strong>Application deadline (online): </strong>
                  {AbsenteeBallotRequestDeadlineOnline || 'N/A'}
                </li>
                <li>
                  <strong>Ballot return deadline (in person): </strong>
                  {AbsenteeBallotReturnDeadlineInPerson || 'N/A'}
                </li>
                <li>
                  <strong>Ballot return deadline (by mail): </strong>
                  {AbsenteeBallotReturnDeadlineMail || 'N/A'}
                </li>
              </ul>
            ),
          },
          {
            title: 'Emergency absentee ballot deadlines',
            valueNode: (
              <ul>
                <li>
                  <strong>Application deadline: </strong>
                  {EmergencyBallotRequestEnd || 'N/A'}
                </li>
                <li>
                  <strong>Ballot return deadline: </strong>
                  {EmergencyBallotReturnDeadline || 'N/A'}
                </li>
              </ul>
            ),
          },
          {
            title: 'Contact your local election office',
            valueNode: (
              <Link
                to={withPrefix(`/local-election-offices/${stateCode}/`)}
                title={`Find your local election office in ${stateName}`}
              >
                Find your local election office in {stateName}
              </Link>
            ),
          },
        ]}
      />
    </TableRow>
  );
}

EmergencyAbsenteeBallotRowRenderer.propTypes = rowRendererProps;
